module.exports = __webpack_public_path__ + "img/avatar.77620fe7.png";